var fvi_referral = {
    cookie_name: "___FVI_CID_011",
    cookie_period: 21, //day
    cookie_obj: null,
    trace_tag: "GROUP_REFERRAL_202403",
    load_cookie: function () {
        var _this = fvi_referral;

        if (_this.cookie_obj !== null)
            return true;

        var cookie_str = getCookie(_this.cookie_name);
        //console.log("cookie_str:|" + cookie_str + "|");

        if (cookie_str === "") {
            return false;
        }

        _this.cookie_obj = JSON.parse(cookie_str);

        //console.log("cookie_obj:");
        //console.log(_this.cookie_obj);

        return _this.cookie_obj != null;

    },

    set_cookie: function () {
        var _this = fvi_referral;

        if (_this.load_cookie()) {
            return true;
        }

        //var current = new Date();
        var url = new URL(location.href);
        const url_params = url.searchParams;
        //ac=29481&cm=4329
        var param_ac = url_params.get('ac');
        var param_cm = url_params.get('cm');

        var init_fvi_obj = new Object();
        init_fvi_obj.cid = is_empty(__st.cid) ? "" : (__st.cid).toString();
        init_fvi_obj.init_at = getCurrentLocalDateTime();
        init_fvi_obj.last_at = getCurrentLocalDateTime();
        init_fvi_obj.ac = param_ac;
        init_fvi_obj.cm = param_cm;
        init_fvi_obj.is_tagged = false;

        var json_str = JSON.stringify(init_fvi_obj);
        _this.cookie_obj = init_fvi_obj;

        setCookie(_this.cookie_name, json_str, _this.cookie_period);
    },

    add_tag_referral_customer: function (customer_id, ac, cm) {
        //console.log("add_tag_referral_customer() customer_id:" + customer_id);
        var _this = fvi_referral;

        if (!_this.load_cookie()) {
            return;
        }
        if (_this.cookie_obj.ac === ac && _this.cookie_obj.cm === cm) {

            if (_this.cookie_obj.is_tagged !== undefined && _this.cookie_obj.is_tagged) {
                return;
            }
            //console.log(_this.cookie_obj.init_at);


            show_loading_spinner();

            $.ajax
            ({
                type: "POST",
                url: "//www.seoulmills.com/apps/extapi/jsapi",//?sstore=sm&action=add_customer_tag",
                data:
                    {
                        sstore:"sm",
                        action:"add_customer_tag",
                        tag: _this.trace_tag,
                        customer_id: customer_id.toString(),
                        min_customer_create_at : _this.cookie_obj.init_at //2024-02-08
                    },
                cache: false,
                dataType: "json",
                async: true,

                success: function (jsonData) {
                    _console_log("[add_customer_tag::RESPONSE]");
                    _console_log(jsonData);

                    if (jsonData.result_code === "S0000") {
                        _this.cookie_obj.cid = customer_id.toString();
                        _this.cookie_obj.is_tagged = true;
                        var json_str = JSON.stringify(_this.cookie_obj);
                        setCookie(_this.cookie_name, json_str, _this.cookie_period);
                    }

                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    _console_log(XMLHttpRequest);

                },
                complete: function () {
                    hide_loading_spinner();
                }
            });


        }
    }
};

jQuery(document).ready(function () {

    if (_customer_id === undefined) {
        _customer_id = is_empty(__st.cid) ? "" : __st.cid;
    }

    if(!is_empty(_customer_id))
    {
        //ac=29481&cm=4329
        fvi_referral.add_tag_referral_customer(_customer_id, "29481", "4329");
    }



    
    
    
    


});
